/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var NetDownloadIcon20Light = forwardRef('NetDownloadIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M9.498 2a.5.5 0 0 1 .5.5L10 12.928a1.37 1.37 0 0 0 .404-.246l3.765-3.295a.5.5 0 0 1 .659.753l-3.766 3.295a2.375 2.375 0 0 1-3.127 0L4.169 10.14a.5.5 0 1 1 .659-.753l3.765 3.295c.123.108.261.19.407.247L8.998 2.5a.5.5 0 0 1 .5-.5Z" }),
        React.createElement("path", { d: "M2.5 16.5A.5.5 0 0 1 3 16h13a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5Z" })));
});
